import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";
import { useTranslation } from "react-i18next";
import { VERSUS_AIRSPEED_BILLY } from "@buddieshr/utils/constants";
import Argument from "@buddieshr/components/templates/argument";
import Footer from "@buddieshr/components/footer";
import Header from "@buddieshr/components/header";
import MetaHeader from "@buddieshr/components/metaHeader";
import ReadyForBilly from "@buddieshr/components/billy/readyForBilly";
import BillyForTeams from "@buddieshr/components/billy/billyForTeams";
import Reviews from "@buddieshr/components/billy/reviews";
import CompareLinks from "@buddieshr/components/billy/compareLinks";
import styles from "@buddieshr/styles/Home_Billy.module.scss";
import AddToSlackButton from "@buddieshr/components/addToSlackButton";
import ComparisonTable from "@buddieshr/components/comparisonTable";
import { PRODUCTS } from "@buddieshr/utils/constants-products";
import G2Logos from "@buddieshr/components/g2Logos";
import PageWrapper from "@buddieshr/components/templates/pageWrapper";

export default function Alternatives(pageProps) {
  const router = useRouter();
  const { t } = useTranslation();
  const app = PRODUCTS.find((r) => r.name === "Billy");

  return (
    <>
      <MetaHeader
        title={t("metaTitleAirspeedAlternative")}
        description={t("metaDescriptionAirspeedAlternative")}
        currentURL={`https://buddieshr.com/${
          router.locale === "en" ? "" : router.locale
        }/${app.slug}/alternatives/airspeed`}
        currentShare={`https://buddieshr.com/img/apps/${app.slug}/share_preview_1.png`}
        pageSlug={`${app.slug}/alternatives/airspeed`}
        locale={router.locale}
      />
      <Header app={app} />
      {/* Header */}
      <div
        className={`${styles.Page_header_wrapper} ${styles.Page_header_alternative}`}
      >
        <h1
          className={styles.bold}
          style={{ width: "900px", maxWidth: "100%", margin: "auto" }}
        >
          {t("alternativesAirspeedTitle")}
        </h1>
        <div
          className={styles.Page_header_description}
          style={{ width: "500px" }}
        >
          {t("alternativesAirspeedDescription")}
        </div>
        <AddToSlackButton
          id="CTA_alternative_Airspeed"
          style={{
            margin: "auto",
            marginTop: "12px",
          }}
          app={app}
        />

        <div className={styles.CTA_hint}>{t("joinThousands")}</div>
      </div>
      {/* END of Header */}
      <div className={styles.Page_inner}>
        <div className={styles.flexArg}>
          <div className={styles.flexLeft}>
            <h2 className={styles.Colored_title}>
              {t("lookingForAlternativesSubtitleAirspeed")}
            </h2>
            <div className={styles.Hide_mobile}>
              <Image
                src="/img/search.png"
                alt="search for alternative of Airspeed"
                width={300}
                height={300}
              />
            </div>
          </div>
          <div className={styles.flexRight}>
            {t("AirspeedAlternativeIntro")}
            <br />
            <br />
            {t("billyDescription", { competitorName: "Airspeed" })}
          </div>
        </div>
        {/* Picture from https://www.manypixels.co/gallery */}
        {/* <Argument
          title="alternativeBdayBotArg4"
          description={"alternativeBdayBotArg4_desc"}
          pictureUrl={"/img/smile.png"}
          showCTA
          reverse
        /> */}
        <PageWrapper>
          <Argument
            title={t("alternativeBdayBotArg2")}
            description={t("alternativeBdayBotArg2_desc")}
            pictureUrl={"/img/ai.png"}
          />
          <Argument
            title={t("alternativeBdayBotArg1")}
            description={t("alternativeBdayBotArg1_desc")}
            pictureUrl={"/img/Winners_Two Color.png"}
            reverse
          />
          <BillyForTeams />
          <Argument
            title={t("alternativeBdayBotArg3")}
            description={t("alternativeBdayBotArg3_desc")}
            pictureUrl={"/img/Video call_Outline.png"}
          />
        </PageWrapper>

        <ComparisonTable
          app={app}
          features={VERSUS_AIRSPEED_BILLY}
          competitorName="Airspeed"
          competitorLogoUrl={"/img/apps/billy/alternatives/airspeed.png"}
        />
        <Reviews />
        <G2Logos />
        <ReadyForBilly app={app} />
        <CompareLinks />
        <br />
        <br />
        <br />
        <br />
        <br />
      </div>
      <Footer app={app} />
    </>
  );
}
